import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  progressOverlayContainer: {
    position: 'relative',
    width: '100%'
  },
  svgContainer: {
    display: 'block',
    width: '100%'
  },
  overlayTextStack: {
    position: 'absolute',
    inset: 0,
    justifyContent: 'space-between',
    padding: '0.1rem 1rem',
    color: theme.vars.palette.common.black,
    [theme.breakpoints.down('md')]: {
      paddingTop: '1.65rem',
      paddingBottom: '1.65rem',
      paddingLeft: '1rem',
      paddingRight: '5rem'
    }
  },
  boxTitleText: {
    fontWeight: 700,
    fontSize: '0.85rem',
    lineHeight: 2.2,
    width: '100%',
    minWidth: 'fit-content',
    paddingRight: '1rem'
  },
  boxTimeText: {
    fontWeight: 500,
    fontSize: '0.75rem',
    lineHeight: 2.2,
    textAlign: 'right',
    paddingRight: '3rem',
    width: '100%',
    minWidth: 'fit-content',
    alignContent: 'center'
  }
}));

export default useStyles;
